import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";
import type { TitleProps } from "./TitleProps";

const titles: Record<string, string> = {
  "/": "Forteana | Ghost hunts, cryptids, overnight strangeness.",
  "/fests": "Places | Forteana",
  "/calendar": "Calendar | Forteana",
  "/about": "About | Forteana",
  "/contact": "Contact | Forteana",
};

const Title: FC<TitleProps> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      return;
    }

    document.title =
      titles[location.pathname] ??
      "Forteana | Ghost hunts, cryptids, overnight strangeness.";
  }, [location, title]);

  return null;
};

export default Title;
